// extracted by mini-css-extract-plugin
export default {"footer":"ueWoKY","container":"VVOZQl","categoryContainer":"ykyfAx"};